import Cookies from 'js-cookie'
import router from '@/router'

const state = {
    //菜单是否折叠
    menuCollapse: Cookies.get("app.menuCollapse") == 'true' ? true : false,
    //界面选项卡列表
    tabs: [],
    // 当前选中选项卡的name
    tabsName: "index",
    //记住登陆名
    loginName: Cookies.get("app.loginName") || "",
}
// 复杂的改变state 可以定义，其它的都可以采用通用方法
const mutations={
    /**
     * 关闭tab选项卡
     */
    closeTab:function(state, route){
        //如果当前路由等于tab
      var index = state.tabs.findIndex(item => {
        return item.fullPath == route.fullPath;
      });
      if(index!=-1&&state.tabs.length>index){
        this.commit("splice", ["app.tabs", index]);
      }
    }
}

export default {
    namespaced: true,
    state,
    mutations
}